import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { Loader } from '../../components/common';
import { Layout } from '../../layouts';
import { selectTeam } from '../../redux';
import TeamDetails from './TeamDetails';
/**
 * TODO: Merge this component with `TeamDetails`
 */
const Team = () => {
    const { team, isLoading } = useSelector(selectTeam);
    return (_jsx(Layout, { title: isLoading || !team?.name ? _jsx(Loader, { className: "justify-start items-center h-[40px]", size: 12 }) : team.name, children: _jsx(TeamDetails, {}) }));
};
export default Team;
